var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CaretUp"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector (Stroke)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3536 9.15923C13.5488 9.37224 13.5488 9.7176 13.3536 9.93062L8.35355 15.3852C8.15829 15.5982 7.84171 15.5982 7.64645 15.3852C7.45118 15.1721 7.45118 14.8268 7.64645 14.6138L12.2929 9.54492L7.64645 4.47607C7.45119 4.26306 7.45119 3.91769 7.64645 3.70468C7.84171 3.49167 8.15829 3.49167 8.35355 3.70468L13.3536 9.15923Z",
    fill: "#343C6A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3536 9.15923C13.5488 9.37224 13.5488 9.7176 13.3536 9.93062L8.35355 15.3852C8.15829 15.5982 7.84171 15.5982 7.64645 15.3852C7.45118 15.1721 7.45118 14.8268 7.64645 14.6138L12.2929 9.54492L7.64645 4.47607C7.45119 4.26306 7.45119 3.91769 7.64645 3.70468C7.84171 3.49167 8.15829 3.49167 8.35355 3.70468L13.3536 9.15923Z",
    fill: "#343C6A"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke) (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7071 10.3168C14.0976 9.89082 14.0976 9.20009 13.7071 8.77406L13.7071 10.3168ZM13.7071 10.3168L8.70711 15.7714C8.31658 16.1974 7.68342 16.1974 7.29289 15.7714C6.90237 15.3454 6.90237 14.6546 7.29289 14.2286L11.5858 9.54545L7.29289 4.8623C6.90237 4.43627 6.90237 3.74555 7.29289 3.31952C7.68342 2.89349 8.31658 2.89349 8.70711 3.31952L13.7071 8.77406M12.2929 9.54545L7.64645 14.6143C7.45118 14.8273 7.45118 15.1727 7.64645 15.3857C7.84171 15.5987 8.15829 15.5987 8.35355 15.3857L13.3536 9.93115C13.5488 9.71814 13.5488 9.37277 13.3536 9.15976L8.35355 3.70521C8.15829 3.4922 7.84171 3.4922 7.64645 3.70521C7.45119 3.91823 7.45119 4.26359 7.64645 4.4766L12.2929 9.54545Z",
    fill: "#343C6A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/ChevronRight.79b0a28b6f6a354c7fc1b5a5ed714d30.svg";
export { ForwardRef as ReactComponent };